import HeaderPortal from "components/portal/header-portal";
import { FormLabel } from "components/form";
import { FormField, FormItem, FormMessage } from "ui/components/form";
import { Form } from "react-crud-form";
import React from "react";
import { casestudySchema } from "../form/schema";
import { Button } from "ui/index";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import ChatAttachmentInput from 'components/file-upload/chat-input';
import { useUpdateCasestudyVideo } from "./mutation";
import { fetchCaseStudyDataforForm } from "../form/read";
import { CASESTUDY_FIELDS } from "../form/constants";

export default function VideoForm() {

    const { casestudyId } = useParams();
    const updateMutation = useUpdateCasestudyVideo({ casestudyId });

    const form = useForm({
        defaultValues: {
            video: "",
        },
    });

    async function handleRead(casestudyId) {
        const fields = [...CASESTUDY_FIELDS];
        return await fetchCaseStudyDataforForm({ casestudyId, fields });
    }

    async function handleUpdate(id, context) {
        const values = context.dirtyValues;
        const response = await updateMutation.mutateAsync({
            caseStudyId: id,
            values,
        });
    }

    return (
        <div className="flex-1 max-w-md p-4">
            <Form
                form={form}
                read={handleRead}
                update={handleUpdate}
                itemId={casestudyId || "+"}
                schema={casestudySchema}
            >
                {({
                    isCreating,
                    createItem,
                    isNewItem,
                    isUpdating,
                    updateItem,
                    isDirty,
                }) => {
                    return (
                        <div className="space-y-6">

                            {/* video */}
                            <FormField
                                control={form.control}
                                name="video"
                                render={({ field }) => {
                                    return (
                                        <FormItem>
                                            <FormLabel>Video</FormLabel>
                                            <ChatAttachmentInput
                                                value={field.value}
                                                onChange={field.onChange}
                                                disabled={isCreating || isUpdating}
                                                preview={true}
                                            />
                                            <FormMessage />
                                        </FormItem>
                                    );
                                }}
                            />

                            {/* Portal buttons similar to TimesheetLog */}
                            <HeaderPortal>
                                {isNewItem ? (
                                    <Button
                                        variant="default"
                                        isLoading={isCreating}
                                        onClick={createItem}
                                    >
                                        Save
                                    </Button>
                                ) : (
                                    <Button
                                        variant="default"
                                        isLoading={isUpdating}
                                        disabled={!isDirty}
                                        onClick={updateItem}
                                    >
                                        Save
                                    </Button>
                                )}
                            </HeaderPortal>
                        </div>
                    );
                }}
            </Form>
        </div>
    );
};
